import { Badge } from '@src/design-system/badge';
import { NoteCardHeaderProfileInfo } from './note-card-header-profile-info';
import { NoteCardHeaderActions } from './note-card-header-actions';
import { dayjsUtils } from '@src/shared/utils/helpers/dayjs';
import { getChannelIcon } from '../../pages/list/dialogs/lead-notes-add-dialog/helpers';
import { useGetMe } from '@shared/services/get-me';

import type { TLeadNote } from '@src/shared/types/lead-note';

const FOLLOW_UP_BADGE_STYLES = {
  future: 'rounded-md bg-[#E3EAFD] text-[#133A9A]',
  pastResolved: 'rounded-md bg-[#D1FAE4] text-[#166E3F]',
  pastUnresolved: 'rounded-md bg-[#FCE5E4] text-[#9A1C13]',
} as const;

function getFollowUpBadgeStyle(
  nextFollowUpDate: string,
  isResolved?: boolean
): (typeof FOLLOW_UP_BADGE_STYLES)[keyof typeof FOLLOW_UP_BADGE_STYLES] {
  const followUp = dayjsUtils(nextFollowUpDate).startOf('day');
  const today = dayjsUtils().startOf('day');
  const isFuture = followUp.isAfter(today);

  if (isResolved) return FOLLOW_UP_BADGE_STYLES.pastResolved;
  if (isFuture) return FOLLOW_UP_BADGE_STYLES.future;
  return FOLLOW_UP_BADGE_STYLES.pastUnresolved;
}

export const NoteCardHeader = ({ note }: { note: TLeadNote }) => {
  const ChannelIcon = getChannelIcon(note.channel);
  const { data: currentUser } = useGetMe();
  const isPartner = currentUser?.type === 'PARTNER';
  const isNoteCreatedByCurrentUser =
    !!currentUser &&
    (isPartner && note.created_by_partner
      ? note.created_by_partner.id === currentUser.id
      : note.created_by?.id === currentUser.id);

  return (
    <div className='flex justify-between items-center'>
      <NoteCardHeaderProfileInfo note={note} />

      <div className='flex items-center gap-2'>
        {note.next_follow_up_date && (
          <Badge
            className={getFollowUpBadgeStyle(
              note.next_follow_up_date,
              note.is_resolved
            )}
          >
            {ChannelIcon && (
              <ChannelIcon
                className='me-1'
                size={16}
              />
            )}
            {dayjsUtils(note.next_follow_up_date).format('D MMM YYYY')}
          </Badge>
        )}

        {isNoteCreatedByCurrentUser && <NoteCardHeaderActions note={note} />}
      </div>
    </div>
  );
};
